import { Box } from '@mui/material';
import RafflePreviousWinners from '../RafflePreviousWinners/RafflePreviousWinners';

export type WinnerItem = {
  id: string;
  name: string;
  winningDate: Date;
  prizeAmount: string;
  discordUsername?: string;
};

type Props = {
  winners: WinnerItem[];
};

const RaffleWinnersCarousel = ({ winners }: Props) => {
  if (!winners.length) return null;

  const marqueeWinners = winners.length > 1 ? [...winners, ...winners] : winners;
  const durationSeconds = Math.max(11, winners.length * 4.25);

  return (
    <Box
      sx={{
        width: '100%',
        overflow: 'hidden',
        py: 1.5,
        position: 'relative',
        '@keyframes winnersMarquee': {
          from: {
            transform: 'translateX(0)'
          },
          to: {
            transform: winners.length > 1 ? 'translateX(-50%)' : 'translateX(0)'
          }
        }
      }}
    >
      <Box
        sx={{
          display: 'flex',
          width: 'max-content',
          gap: { xs: 1, sm: 1.25, md: 1.5 },
          animation:
            winners.length > 1
              ? `winnersMarquee ${durationSeconds}s linear infinite`
              : 'none',
          '&:hover': {
            animationPlayState: 'paused'
          }
        }}
      >
        {marqueeWinners.map((winner, index) => (
          <Box
            key={`${winner.id}-${index}`}
            sx={{
              flex: '0 0 auto',
              width: { xs: 310, sm: 380, md: 430 }
            }}
          >
            <RafflePreviousWinners
              name={winner.name}
              winningDate={winner.winningDate}
              prizeLabel={winner.prizeAmount}
              discordUsername={winner.discordUsername}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default RaffleWinnersCarousel;
